/* tslint:disable */
/* eslint-disable */
/**
 * Logistics
 * 物流管理用API
 *
 * The version of the OpenAPI document: 1.0
 * Contact: kiuchi@wcdi.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateStockupsRequestStockupsInner
 */
export interface UpdateStockupsRequestStockupsInner {
    /**
     * 
     * @type {string}
     * @memberof UpdateStockupsRequestStockupsInner
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof UpdateStockupsRequestStockupsInner
     */
    listingOrder?: number;
}

/**
 * Check if a given object implements the UpdateStockupsRequestStockupsInner interface.
 */
export function instanceOfUpdateStockupsRequestStockupsInner(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;

    return isInstance;
}

export function UpdateStockupsRequestStockupsInnerFromJSON(json: any): UpdateStockupsRequestStockupsInner {
    return UpdateStockupsRequestStockupsInnerFromJSONTyped(json, false);
}

export function UpdateStockupsRequestStockupsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateStockupsRequestStockupsInner {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'listingOrder': !exists(json, 'listing_order') ? undefined : json['listing_order'],
    };
}

export function UpdateStockupsRequestStockupsInnerToJSON(value?: UpdateStockupsRequestStockupsInner | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'listing_order': value.listingOrder,
    };
}

